import { apiClient } from '~/services/apiClient';

const END_POINT = '/client-meta';

export const collectMeta = payload => apiClient.post(END_POINT, payload);
